function saveInLocalStorage(keyName: string, value: string) {
  window.localStorage.setItem(keyName, value);
}

function readFromLocalStorage(keyName: string) {
  return window.localStorage.getItem(keyName);
}

export { saveInLocalStorage, readFromLocalStorage };
